import { useTranslation } from 'react-i18next';
import FormElement from '@wix/da-ds/pkg/formControls/layouts/FormElement';
import InputLabelText from '@wix/da-ds/pkg/formControls/lego/InputLabelText';
import RadioButton from '@wix/da-ds/pkg/RadioButton';
import GroupSelectField from '../GroupSelectField';
import GalleryFolderSelect from './GalleryFolderSelect';
import StashFolderSelect from './StashFolderSelect';
import { useSubmitField } from '../../hooks/useSubmitField';

import s from './OriginalsVisibilityField.scss';

const OriginalsVisibilityField = () => {
  const { t } = useTranslation();
  const {
    id,
    field: { onChange, value },
  } = useSubmitField('originalVisibility', {
    initAdapter: ({ originalsDelivery }) =>
      originalsDelivery ? (originalsDelivery.published ? 'public' : 'private') : 'public',
    submitAdapter: ({ originalVisibility }) => ({
      published: originalVisibility === 'public',
    }),
  });

  return (
    <FormElement
      className={s['root']}
      inputId={id}
      label={
        <InputLabelText>{t('originals.deviationSubmit.form.visibility.label')}</InputLabelText>
      }
    >
      <RadioButton
        className={s['option']}
        inputClassName={s['option-input']}
        name="visibility"
        value="public"
        checked={value === 'public'}
        onChange={() => onChange('public')}
      >
        <strong className={s['option-title']}>
          {t('originals.deviationSubmit.form.visibility.public.label')}
        </strong>
        <p className={s['option-description']}>
          {t('originals.deviationSubmit.form.visibility.public.description')}
        </p>
        <GalleryFolderSelect className={s['folder-select']} />
        <GroupSelectField className={s['group-select']} />
      </RadioButton>

      <RadioButton
        className={s['option']}
        inputClassName={s['option-input']}
        name="visibility"
        value="private"
        checked={value === 'private'}
        onChange={() => onChange('private')}
      >
        <strong className={s['option-title']}>
          {t('originals.deviationSubmit.form.visibility.private.label')}
        </strong>
        <p className={s['option-description']}>
          {t('originals.deviationSubmit.form.visibility.private.description')}
        </p>
        <StashFolderSelect className={s['folder-select']} />
      </RadioButton>
    </FormElement>
  );
};
OriginalsVisibilityField.displayName = 'OriginalsVisibilityField';

export default OriginalsVisibilityField;
